import { globalErrorMsg } from '@bingads-webui-campaign/hotel-common-upsert';
import { validateBidAdjustment } from '../components/utility';

export function getCheckinDayBasicConfig(i18n) {
  const columns = [
    {
      key: 'day', name: i18n.getString(_TL_('Day of the week')), fieldName: 'day', minWidth: 100, maxWidth: 117, type: 'string', className: 'border-right', headerClassName: 'target-custom-header',
    },
  ];
  return {
    basicConfig: {
      columns,
      showAddBtn: false,
      showSettingToggle: true,
      titleKey: i18n.getString(_TL_('Check-in day')),
      topicKey: 'pop_BA_CampaignTargets_CheckinDay',
      minBid: -90,
      maxBid: 900,
      extraBid: [-100],
    },
  };
}


export const checkinDayDefaultSetting = [{
  day: _TL_('Monday'),
  bidAdjustmentDropdown: 'Increase by',
  bidAdjustmentInput: 0,
},
{
  day: _TL_('Tuesday'),
  bidAdjustmentDropdown: 'Increase by',
  bidAdjustmentInput: 0,
},
{
  day: _TL_('Wednesday'),
  bidAdjustmentDropdown: 'Increase by',
  bidAdjustmentInput: 0,
},
{
  day: _TL_('Thursday'),
  bidAdjustmentDropdown: 'Increase by',
  bidAdjustmentInput: 0,
},
{
  day: _TL_('Friday'),
  bidAdjustmentDropdown: 'Increase by',
  bidAdjustmentInput: 0,
},
{
  day: _TL_('Saturday'),
  bidAdjustmentDropdown: 'Increase by',
  bidAdjustmentInput: 0,
},
{
  day: _TL_('Sunday'),
  bidAdjustmentDropdown: 'Increase by',
  bidAdjustmentInput: 0,
}];

export const isCheckinDayTargetValid = (checkinDay, patchErrMsg = function () { }) => {
  let isValid = true;

  checkinDay.filter(item => item.Status !== 'Deleted').forEach((item) => {
    let validateValue = item.bidAdjustmentInput;
    if (item.bidAdjustmentDropdown === 'Decrease by') {
      validateValue = -validateValue;
    }
    if (validateBidAdjustment({
      value: validateValue, min: -90, max: 900, extra: [-100],
    })) {
      isValid = false;
    }
  });
  if (isValid) {
    patchErrMsg('checkinDay', '');
  } else {
    patchErrMsg('checkinDay', globalErrorMsg);
  }
  return isValid;
};
